import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  Input,
  VStack,
  useToast,
} from "@chakra-ui/react";
import CardImageUpload from "./CardImageUpload";

const CardForm = ({ isOpen, onClose, onSubmit, initialData = null }) => {
  const [formData, setFormData] = React.useState({
    cardId: "",
    description: "",
    title: "",
    name: "",
    scientificIdentity: "",
    tailNumber: "",
    cardFrontImage: "",
    cardBackImage: "",
    invertMaterials: false,
    foilMask: "",
  });

  const [imageErrors, setImageErrors] = React.useState({
    cardFrontImage: "",
    cardBackImage: "",
  });

  React.useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData({
        cardId: "",
        description: "",
        title: "",
        name: "",
        scientificIdentity: "",
        tailNumber: "",
        cardFrontImage: "",
        cardBackImage: "",
        invertMaterials: false,
        foilMask: "",
      });
    }
    setImageErrors({ cardFrontImage: "", cardBackImage: "" });
  }, [initialData]);

  const toast = useToast();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleImageChange = (field) => (url) => {
    setFormData((prev) => ({
      ...prev,
      [field]: url,
    }));
    setImageErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const validateImages = () => {
    const errors = {
      cardFrontImage: formData.cardFrontImage ? "" : "Card front image is required.",
      cardBackImage: formData.cardBackImage ? "" : "Card back image is required.",
    };
    setImageErrors(errors);
    return !errors.cardFrontImage && !errors.cardBackImage;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateImages()) {
      toast({
        title: "Missing images",
        description: "Both card front and back images are required.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    try {
      await onSubmit(formData);
      onClose();
      // toast({
      //   title: `Card ${initialData ? "updated" : "created"} successfully`,
      //   status: "success",
      //   duration: 3000,
      //   isClosable: true,
      // });
    } catch (error) {
      // toast({
      //   title: "Error",
      //   description: error.message,
      //   status: "error",
      //   duration: 3000,
      //   isClosable: true,
      // });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <form onSubmit={handleSubmit}>
          <ModalHeader>
            {initialData ? "Edit Card" : "Add New Card"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4}>
              {!initialData && (
                <FormControl isRequired>
                  <FormLabel>Card ID</FormLabel>
                  <Input
                    name="cardId"
                    value={formData.cardId}
                    onChange={handleChange}
                  />
                </FormControl>
              )}
              <FormControl isRequired>
                <FormLabel>Title</FormLabel>
                <Input
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel>Name</FormLabel>
                <Input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Description</FormLabel>
                <Input
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Scientific Identity</FormLabel>
                <Input
                  name="scientificIdentity"
                  value={formData.scientificIdentity}
                  onChange={handleChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Tail Number</FormLabel>
                <Input
                  name="tailNumber"
                  value={formData.tailNumber}
                  onChange={handleChange}
                />
              </FormControl>
              <FormControl>
                <CardImageUpload
                  label="Foil Mask"
                  value={formData.foilMask}
                  onChange={handleImageChange("foilMask")}
                />
              </FormControl>
              <FormControl>
                <Checkbox
                  name="invertMaterials"
                  isChecked={formData.invertMaterials}
                  onChange={handleChange}
                >
                  Invert Materials
                </Checkbox>
              </FormControl>
              <FormControl isRequired isInvalid={!!imageErrors.cardFrontImage}>
                <CardImageUpload
                  label="Card Front Image"
                  value={formData.cardFrontImage}
                  onChange={handleImageChange("cardFrontImage")}
                  isInvalid={!!imageErrors.cardFrontImage}
                  errorMessage={imageErrors.cardFrontImage}
                />
              </FormControl>
              <FormControl isRequired isInvalid={!!imageErrors.cardBackImage}>
                <CardImageUpload
                  label="Card Back Image"
                  value={formData.cardBackImage}
                  onChange={handleImageChange("cardBackImage")}
                  isInvalid={!!imageErrors.cardBackImage}
                  errorMessage={imageErrors.cardBackImage}
                />
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button
              type="submit"
              mr={3}
              background="linear-gradient(100.88deg, #463C8F -1.15%, #CE0C88 177.18%)"
              color="white"
              _hover={{
                background:
                  "linear-gradient(100.88deg, #463C8F -1.15%, #CE0C88 177.18%)",
                opacity: 0.9,
              }}
            >
              {initialData ? "Update" : "Create"}
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default CardForm;
